import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Loader from "../../../../components/Loader/Loader";

const UpdateResumePopup = ({
  open,
  onClose,
  resumes,
  isLoading,
  selectedDocId,
  onSelect,
  onUpdate,
}) => {
  const selectedResume = resumes?.find(
    (resume) => resume.docId === selectedDocId?.docId,
  );

  const isRadioSelected = Boolean(selectedResume);
  const isCurrentResume = Boolean(selectedResume?.isCurrent);
  const isUpdateDisabled = !isRadioSelected || isCurrentResume;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      className="updateResumeDialog"
      PaperProps={{ style: { borderRadius: "10px", overflow: "hidden" } }}
    >
      <DialogTitle className="updateResumeDialogHeader">
        Update Resume
        <CloseIcon
          className="updateResumeCloseIcon"
          onClick={onClose}
        />
      </DialogTitle>
      <DialogContent className="updateResumeDialogBody">
        <p className="updateResumeSelectLabel">Select from existing resumes</p>
        {isLoading ? (
          <div className="updateResumeLoader">
            <Loader />
          </div>
        ) : resumes?.length > 0 ? (
          <div className="updateResumeList">
            {resumes.map((resume) => {
              const isSelected = selectedDocId?.docId === resume.docId;
              const isNA = resume.matchPercentage === -1;
              const percentage =
                resume.matchPercentage == null || resume.matchPercentage === -1
                  ? 0
                  : resume.matchPercentage <= 1
                  ? Math.round(resume.matchPercentage * 100)
                  : Math.round(resume.matchPercentage);
              const fileIcon =
                (resume.fileName || "").toLowerCase().endsWith(".pdf")
                  ? "/assests/img/pdf.svg"
                  : "/assests/img/docx.svg";
              return (
                <label
                  key={resume.docId}
                  className={`updateResumeItem${isSelected ? " selected" : ""}`}
                >
                  <input
                    type="radio"
                    name="updateResumeSelection"
                    className="updateResumeRadio"
                    checked={isSelected}
                    onChange={() =>
                      onSelect({
                        docId: resume.docId,
                        percentage: resume.matchPercentage,
                      })
                    }
                  />
                  <img
                    src={process.env.PUBLIC_URL + fileIcon}
                    alt=""
                    className="updateResumeFileIcon"
                  />
                  <div className="updateResumeFileInfo">
                    <div className="updateResumeFileName">
                      <span className="resumeTitle">{resume.fileName}</span>
                      {resume.isCurrent && (
                        <span className="updateResumeCurrentBadge">Current</span>
                      )}
                    </div>
                    <div className="updateResumeMeta">
                      {resume.uploadedBy}
                      {resume.uploadedBy && resume.uploadedOn ? " · " : ""}
                      {resume.uploadedOn}
                    </div>
                  </div>
                  <div
                    className="updateResumeMatchRing"
                    style={
                      isNA
                        ? { background: "#ececec" }
                        : {
                            background: `conic-gradient(#3b4046 ${percentage}%, #ececec ${percentage}%)`,
                          }
                    }
                  >
                    <div className="updateResumeMatchRingInner">
                      {isNA ? "NA" : `${percentage}%`}
                    </div>
                  </div>
                </label>
              );
            })}
          </div>
        ) : (
          <div className="updateResumeEmpty">No resumes found</div>
        )}
      </DialogContent>
      {resumes?.length >= 1 && (
        <DialogActions className="updateResumeDialogFooter">
          <Button
            className="updateResumeUpdateBtn"
            disabled={isUpdateDisabled}
            onClick={onUpdate}
          >
            Update
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default UpdateResumePopup;
